import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContractError, SelectInput } from 'src/app/core/models/models';
import { BrandZone } from 'src/app/core/models/fare-family.model';

@Component({
  selector: 'app-fare-families',
  templateUrl: './fare-families.component.html',
  styleUrls: ['./fare-families.component.scss'],
})
export class FareFamiliesComponent implements OnInit {
  @Input() error: ContractError;
  @Input() loading: boolean;
  zonesValues: BrandZone[];
  selectedAlternative = 0;
  selectedOriginal = 0;
  SELECT_ZONES: SelectInput[];
  form: FormGroup;
  constructor(private fb: FormBuilder) {}

  @Input() set zones(values: BrandZone[]) {
    this.zonesValues = values;
    this.SELECT_ZONES = (values || []).reduce(
      (names, zone, index) =>
        names.concat({ name: zone.name, code: index }, []),
      []
    );
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      originals: [0],
      alternatives: [0],
    });
  }
}
